import { render, staticRenderFns } from "./EditFAQ.vue?vue&type=template&id=96e42bea&scoped=true&"
import script from "./EditFAQ.vue?vue&type=script&lang=js&"
export * from "./EditFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e42bea",
  null
  
)

export default component.exports